// biome-ignore lint/suspicious/noExplicitAny: biome migration
export function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
    let timeout: ReturnType<typeof setTimeout>

    return (...args: Parameters<typeof func>) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => func(...args), wait)
    }
}
